import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-deployments.sidebar-content.configuration.environment-type.title',
		defaultMessage: 'Environment types',
		description: 'The title of filter options for environment types',
	},
	production: {
		id: 'software-deployments.sidebar-content.configuration.environment-type.production',
		defaultMessage: 'Production',
		description:
			'One of the environment type view configuration option label. Production environment type',
	},
	staging: {
		id: 'software-deployments.sidebar-content.configuration.environment-type.staging',
		defaultMessage: 'Staging',
		description:
			'One of the environment type view configuration option label. Staging environment type',
	},
	testing: {
		id: 'software-deployments.sidebar-content.configuration.environment-type.testing',
		defaultMessage: 'Testing',
		description:
			'One of the environment type view configuration option label. Testing environment type',
	},
	development: {
		id: 'software-deployments.sidebar-content.configuration.environment-type.development',
		defaultMessage: 'Development',
		description:
			'One of the environment type view configuration option label. Development environment type',
	},
	unmapped: {
		id: 'software-deployments.sidebar-content.configuration.environment-type.unmapped',
		defaultMessage: 'Unmapped',
		description:
			'One of the environment type view configuration option label. Unmapped environment type',
	},
});
